import React, { useState } from "react";
import debounce from "lodash/debounce";
import { Container } from "react-bootstrap";
import DebounceWithState from "./DebounceWithState";

const Debouncedemo = () => {
  const InputWithDebouncedOnchange = () => {
    const onChange = (e) => {
      console.log("Changed value:", e.target.value);
    };

    const debouncedOnChange = debounce(onChange, 1000);

    return (
      <input onChange={debouncedOnChange} placeholder="Search Something" />
    );
  };

  return (
    <>
      <Container>
        <h3>Debounced onChange</h3>
        {/* <InputWithDebouncedOnchange /> */}
        <DebounceWithState />
      </Container>
    </>
  );
};

export default Debouncedemo;
